import { configureStore, isPlain } from "@reduxjs/toolkit";
import createSagaMiddleware, { END } from "redux-saga";
import rootReducer from "../reducers";
import studentGroup from "@app/routes/studentGroup/store/studentGroupSlice";
import studentsV2 from "@app/routes/studentsV2/store/studentSlice";
import createSession from "@app/common/calendar/components/createSession/V3/store/CreateSessionSlice";
import fullScreenSlice from "@app/routes/full_screen/store/fullScreenSlice";
import vocabulary from "@app/routes/vocabulary/store/vocabularySlice";
import reading from "@app/routes/activities/reading/store/readingSlice";
import spelling from "@app/routes/activities/spelling/store/spellingSlice";

//-------- Treatment V3 --------
import treatmentWSMiddleware from "@app/routes/treatmentV3/store/websocketMiddleware";
import analyticsMW from "./analytics/analyticsMW";
import measurementsMW from "./measurements/measurementsMW";
import treatmentServerDataSlice from "@app/routes/treatmentV3/store/treatmentServerDataSlice";
import administrationSlice from "@app/routes/treatmentV3/store/administrationSlice";
import studioSlice from "@app/routes/treatmentV3/store/studioSlice";
import websocketSlice from "@app/routes/treatmentV3/store/websocketSlice";
import treatmentStudentSideSlice from "@app/routes/treatmentV3/store/studentSlice";
import treatmentContentSlice from "@app/routes/treatmentV3/store/contentSlice";
import h5pGamesSlice from "@app/routes/treatmentV3/store/h5pGamesSlice";
import articulationSlice from "@app/routes/treatmentV3/store/articulationSlice";
import speechSlice from "@app/routes/treatmentV3/store/speechSlice";
import videoSlice from "@app/routes/treatmentV3/store/videoSlice";
import youtubeSlice from "@app/routes/treatmentV3/store/youtubeSlice";
import techStatusSlice from "@app/routes/treatmentV3/store/techStatusSlice";
import chatSlice from "@app/routes/treatmentV3/store/chatSlice";
import activityLibrarySlice from "@app/routes/treatmentV3/store/activityLibrarySlice";
import metricsMW from "./metrics/metricsMW";
import selfPractice from "@app/routes/treatmentV3/store/selfPracticeSlice";

import { sanitizerConfig } from "./sanitizer/sanitizer";

const reducers = {
  ...rootReducer,
  studentGroup,
  studentsV2,
  createSession,
  fullScreenSlice,
  vocabulary,
  reading,
  spelling,
  //-------- Treatment V3 --------
  treatmentServerDataSlice,
  treatmentContentSlice,
  administrationSlice,
  studioSlice,
  websocketSlice,
  treatmentStudentSideSlice,
  h5pGamesSlice,
  articulationSlice,
  speechSlice,
  videoSlice,
  youtubeSlice,
  techStatusSlice,
  chatSlice,
  activityLibrarySlice,
  selfPractice,
  //-------- Treatment V4 --------
  // treatmentServerDataSliceV4,
  // administrationSliceV4,
  // websocketSliceV4,
  // videoSliceV4,
  // techStatusSliceV4,
  // chatSliceV4,
  // treatmentContentSliceV4,
  // metricsMWV4,
  // createSessionV4,
  // studentSkillSliceV4,
  // measurementsSliceV4,
  // h5pGamesSliceV4,
  // articulationSliceV4,
  // speechSliceV4,
  // treatmentStudentSideSliceV4,
  // // studioSliceV4,
  // activityLibrarySliceV4,
};

const configureAppStore = preloadedState => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware(
        {
          serializableCheck: {
            isSerializable: (v) => isPlain(v) || typeof v === "function", //pretty bad... should fix it    treatment.entities[1830].fnHandler
            ignoredActions: [
              "websocketSlice/wsConnected", "websocketSlice/wsReconnect", "websocketSliceV4/wsConnected", "websocketSliceV4/wsReconnect", "activityLibrarySlice/fetchLibraryData/fulfilled",
            ],
            ignoredPaths: [
              "websocketSlice.UNSAFE_websocket", "websocketSliceV4.UNSAFE_websocket", "activityLibrarySlice",
            ],
          },
          immutableCheck: { ignoredPaths: ["websocketSlice.UNSAFE_websocket", "websocketSliceV4.UNSAFE_websocket", "activityLibrarySlice"] },
        },
      ).concat(sagaMiddleware, treatmentWSMiddleware, analyticsMW, measurementsMW, metricsMW),
    devTools: process.env.NODE_ENV !== "production" && sanitizerConfig,
    preloadedState,
  });

  if (process.env.NODE_ENV !== "production" && module.hot) {
    module.hot.accept("../reducers", () => store.replaceReducer(reducers));
  }

  store.close = () => store.dispatch(END);
  store.runSaga = sagaMiddleware.run;
  return store;
};

export default configureAppStore;
